import { Injectable } from '@angular/core';

import type { ParsedValidationError } from '../utils/api-error.util';

export type FormValidationErrorHandler = (result: ParsedValidationError) => boolean | void;

/**
 * Lets the active view register a handler for VALIDATION_ERROR responses.
 * Used by the validation-error interceptor before falling back to a global toast.
 * Return `false` when the handler did not consume the error (e.g. modal closed).
 */
@Injectable({ providedIn: 'root' })
export class FormValidationErrorService {
  private handler: FormValidationErrorHandler | null = null;

  register(handler: FormValidationErrorHandler): () => void {
    this.handler = handler;
    return () => {
      if (this.handler === handler) {
        this.handler = null;
      }
    };
  }

  /** Returns true when a registered handler consumed the validation error. */
  dispatch(result: ParsedValidationError): boolean {
    if (!this.handler) {
      return false;
    }
    const consumed = this.handler(result);
    return consumed !== false;
  }
}
